// const BASE_URL = 'http://161.35.5.240:5000/'; // Your VM's IP and backend port
const BASE_URL = 'http://localhost:5001';

export default BASE_URL;
export const base_path ='/'
export const img_path ='/'
